export const getWhatsappUrl = ({ phone, text }) => {
  phone = (phone || '').replace('+', '');
  const searchStr = new URLSearchParams({ phone, text }).toString();
  return `https://api.whatsapp.com/send?${searchStr}`;
};

export const whatsappUs = ({ text }) => {
  window.open(getWhatsappUrl({ phone: '85266370320', text: text }), '_blank');
};
